// extracted by mini-css-extract-plugin
module.exports = {"NotTranslated":"NotTranslated_NotTranslated__67u4G","Title":"NotTranslated_Title__W4Y82","Message":"NotTranslated_Message__cmb4Q","Close":"NotTranslated_Close__axN7p"};